import { Popup } from 'react-vant';
import { H5_CONTACT_INFO } from '../../config';
import styles from './index.module.scss';

interface ContactPopupProps {
  visible: boolean;
  onClose: () => void;
  onConsult?: () => void;
}

export function ContactPopup({ visible, onClose, onConsult }: ContactPopupProps) {
  const { address, phone, email, website, websiteUrl } = H5_CONTACT_INFO;

  const handleHotline = () => {
    if (typeof window !== 'undefined') {
      window.location.href = `tel:${phone}`;
    }
  };

  const handleConsult = () => {
    onConsult?.();
  };

  return (
    <Popup
      visible={visible}
      position="bottom"
      round
      onClose={onClose}
      className={styles.popup}
    >
      <div className={styles.panel}>
        <div className={styles.header}>
          <h3 className={styles.title}>联系我们</h3>
          <button type="button" className={styles.close} onClick={onClose} aria-label="关闭">
            ×
          </button>
        </div>

        <div className={styles.list}>
          <div className={styles.item}>
            <span className={`${styles.icon} ${styles.pin}`} aria-hidden>
              📍
            </span>
            <div className={styles.content}>
              <div className={styles.label}>联系地址</div>
              <div className={styles.value}>{address}</div>
            </div>
          </div>

          <div className={styles.item}>
            <span className={`${styles.icon} ${styles.phone}`} aria-hidden>
              📞
            </span>
            <div className={styles.content}>
              <div className={styles.label}>联系电话</div>
              <a className={styles.link} href={`tel:${phone}`}>
                {phone}
              </a>
            </div>
          </div>

          <div className={styles.item}>
            <span className={`${styles.icon} ${styles.mail}`} aria-hidden>
              ✉️
            </span>
            <div className={styles.content}>
              <div className={styles.label}>联系邮箱</div>
              <a className={styles.link} href={`mailto:${email}`}>
                {email}
              </a>
            </div>
          </div>

          <div className={styles.item}>
            <span className={`${styles.icon} ${styles.web}`} aria-hidden>
              🌐
            </span>
            <div className={styles.content}>
              <div className={styles.label}>联系官网</div>
              <a
                className={styles.link}
                href={websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {website}
              </a>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.btn} onClick={handleHotline}>
            📞 客服热线
          </button>
          <button type="button" className={`${styles.btn} ${styles.primary}`} onClick={handleConsult}>
            💬 在线咨询
          </button>
        </div>
      </div>
    </Popup>
  );
}
